import { isBrowserCompatible, MODAL, selectUserRolePermissions } from '@socialive/common';
import { useModal } from '@socialive/modals';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import debounce from '../helpers/debounce';
import { ModalTypes } from '../helpers/enums';
import CustomModal from './CustomModal';

export default function CreateBroadcast({ isHeader }) {
  const { canCreateBroadcast } = useSelector(selectUserRolePermissions);
  const [incompatibleModalOpen, setIncompatibleModalOpen] = useState(false);
  const buttonContainerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const minContainerWidthBeforeShrink = 143; // Magic number estimating the button size

  const modal = useModal({ modalId: MODAL.CREATE_BROADCAST });

  const onCreateBroadcast = useCallback(() => {
    if (isBrowserCompatible()) {
      modal.open();
    } else {
      setIncompatibleModalOpen(true);
    }
  }, [modal]);

  useEffect(() => {
    function handleResize() {
      setIsOverflowing(buttonContainerRef?.current?.offsetWidth < minContainerWidthBeforeShrink);
    }

    handleResize();
    const debouncedResize = debounce(handleResize, 200);
    window.addEventListener('resize', debouncedResize);
    return () => {
      window.removeEventListener('resize', debouncedResize);
    };
  }, []);

  if (!canCreateBroadcast) {
    return null;
  }

  return (
    <div id="broadcast-creator" className="create-broadcast-container" ref={buttonContainerRef}>
      <div className="new-broadcast-button-container">
        <button
          type="button"
          className={classnames('new-broadcast-button', {
            'minimized-button': isOverflowing,
            header: isHeader,
          })}
          onClick={onCreateBroadcast}
        >
          {isOverflowing ? '+' : 'New broadcast'}
        </button>
      </div>
      <CustomModal
        handleOnClose={() => setIncompatibleModalOpen(false)}
        includeButtons={false}
        isOpen={incompatibleModalOpen}
        type={ModalTypes.INCOMPATIBLE_BROWSER}
      />
    </div>
  );
}

CreateBroadcast.defaultProps = {
  isHeader: false,
};

CreateBroadcast.propTypes = {
  isHeader: PropTypes.bool,
};
